<template>
	<div class="date-picker">
		<div class="date-grid">
			<div class="row weekdays">
				<span>
					{{ lang=='he-IL'? 'א':'Sun' }}
				</span>
				<span>
					{{ lang=='he-IL'? 'ב':'Mon' }}
				</span>
				<span>
					{{ lang=='he-IL'? 'ג':'Tue' }}
				</span>
				<span>
					{{ lang=='he-IL'? 'ד':'Wed' }}
				</span>
				<span>
					{{ lang=='he-IL'? 'ה':'Thu' }}
				</span>
				<span>
					{{ lang=='he-IL'? 'ו':'Fri' }}
				</span>
				<span>
					{{ lang=='he-IL'? 'ש':'Sat' }}
				</span>
			</div>

			<div v-for="(row, index) in rows" class="row" :class="`dates-${index+1}`">
				<template v-for="date in row">
					<span v-if="date.active" class="button" :data-date="date.fullDate" @click="toggleDate">{{ date.date }}</span>
					<span v-else>{{ date.date }}</span>
				</template>
			</div>	
		</div>
		<div class="buttons-wrapper">
			<button @click="resetDates">
				{{ lang=='he-IL'? 'נקה':'Clear' }}
			</button>
			<button @click="closeFilter">
				{{ lang=='he-IL'? 'סנן':'Filter' }}
			</button>
		</div>
		<div class="close-button" @click="closeFilter"
			:style="{ 'right': lang=='he-IL'? '100%':'unset',  'left': lang=='he-IL'? 'unset':'100%' }">
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" >
				<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeDates: [],
			startDate: '21.12.2023',
			endDate: '31.12.2023',
			dates: null,
			lang: 'he-IL',
			filterDebounceResolveID: null
		}
	},
	props: {
		isOpen: {
			type: Boolean,
			required: true,
			default: true
		},
	},
	mounted() {
		this.emitter.on('resetDatesFilter', this.resetDates)
		this.emitter.on('gotPosts', this.handlePosts)
		this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
	},
	methods: {
		resetDates(noFiltering) {
			this.activeDates = []
			document.querySelectorAll(".date-grid span.button").forEach(function(elm) {
				elm.classList.remove('active')
			})
			if (!noFiltering) this.filterPosts()
		},
		closeFilter() {
			this.emitter.emit('closeDatesFilter')
		},
		debounceFilterPosts() {
			if (this.filterDebounceResolveID) clearTimeout(this.filterDebounceResolveID)
			this.filterDebounceResolveID = setTimeout(this.filterPosts, 700)
		},
		filterPosts() {
			let activeFullDates = this.activeDates
			this.emitter.emit('filterByDate', activeFullDates)
		},
		toggleDate(e) {
			let date = e.target.dataset.date
			let active = e.target.classList.contains('active')
			e.target.classList.toggle('active')
			if (this.$route.name=='schedule') {
				this.activeDates = []
				document.querySelectorAll(".date-grid span.button").forEach(function(elm) {
					if (elm == e.target) return;
					elm.classList.remove('active')
				})
				if (!active) this.activeDates.push(date)
				this.changeDate()
			} else {
				if (active) this.activeDates.splice(this.activeDates.indexOf(date), 1)
				else this.activeDates.push(date)
				this.debounceFilterPosts() 
			}
		},
		changeDate() {
			this.emitter.emit('changedDate', this.activeDates[0])
		},
		timestampFromString(str, delimiter) {
			let myDate = str.split(delimiter);
			let newDate = new Date( myDate[2], myDate[1] - 1, myDate[0]);
			return newDate.getTime()
		},
		stringFromDate(date, withYear) {
			function padTo2Digits(num) {
				return num.toString().padStart(2, '0');
			}
			let parts
			if (withYear) parts = [
					padTo2Digits(date.getDate()),
					padTo2Digits(date.getMonth() + 1),
					padTo2Digits(date.getFullYear()),
				]
			else parts = [
					padTo2Digits(date.getDate()),
					padTo2Digits(date.getMonth() + 1),
				]
			return parts.join('.');
		}, 
		insertInString(str, index, value) {
			return str.substr(0, index) + value + str.substr(index);
		},
		handlePosts(posts) {
			if (!posts) return
			let movies = posts.filter(p => p['acf']['screening_hours_and_events'])
			let allDates = movies.map(m => {
				let ds = []
				for (let screening of m['acf']['screening_hours_and_events']) {
					let dateString = screening.date
					dateString = this.insertInString(dateString, 4, '/')
					dateString = this.insertInString(dateString, 7, '/')
					let d = new Date(dateString)
					d.setHours(0, 0, 0, 0)
					ds.push(d)
				}
				return ds
			})
			allDates = allDates.flat()
			let uniqueDates = []
			for (let i = 0; i < allDates.length; i++) {
				const d = allDates[i];
				if (!uniqueDates.some(ud => ud.getTime() === d.getTime()))
				uniqueDates.push(d)
			}
			uniqueDates.sort((a, b) => a - b)
			this.dates = uniqueDates
			this.startDate = this.stringFromDate(uniqueDates[0], true)
			this.endDate = this.stringFromDate(uniqueDates[uniqueDates.length - 1], true)
		}
	},
	computed: {
		rows() {
			if (!this.dates || !this.dates.length) return []
			let rows = []
			let firstDateInWidget = new Date(this.dates[0].getTime())
			while (firstDateInWidget.getDay() !== 0) {
				firstDateInWidget.setDate(firstDateInWidget.getDate() - 1)
			}
			let lastDate = new Date(firstDateInWidget.getTime())
			while (lastDate <= this.dates[this.dates.length - 1]) {
				let row = []
				for (let i = 0; i < 7; i++) {
					row.push({
						active: this.dates.some(d => d.getTime() === lastDate.getTime()),
						date: lastDate.getDate(),
						fullDate: this.stringFromDate(lastDate)
					})
					lastDate.setDate(lastDate.getDate() + 1)
				}
				rows.push(row)
			}
			return rows
		}
	}
};
</script>

<style>
.date-picker {
	--pink: #F15794;
	width: 236px;
	height: 160px;
	position: absolute;
	top: 2em;
	right: 0;
	z-index: 1;
	padding: 8px;
	border: 2px solid black;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-shadow: 0px 3px 6px #00000080;
	cursor: default;
}

.date-grid {
	display: flex;
	flex-direction: column;
	font-size: 0.8em;
	flex-grow: 1;
	color: black;
}

.date-grid .row {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	margin: 0;
}

.date-grid .row.weekdays::after {
	content: "";
	width: 700%;
	height: 1px;
	background-color: var(--pink);
	margin-block: 3px 6px;
}

.date-grid .row span {
	text-align: center;
	font-size: 1.1em;
}


.date-grid .row span.button {
	min-width: 1em;
	cursor: pointer;
	color: var(--pink);
}

.date-grid .row span.button.active {
	background-color: var(--pink);
	color: white;
	border-radius: 5px;
}

.buttons-wrapper {
	display: flex;
	justify-content: space-between;
}


.buttons-wrapper button {
	cursor: pointer;
	position: relative;
	color: var(--pink);
	background-color: white;
	border: 1px solid var(--pink);
	box-shadow: 0px 3px 6px #00000080;
	padding: 0 1em !important;
	transition: 300ms ease-in-out;
}

.buttons-wrapper button:focus {
	outline: none !important;
	background-color: white;
}

.buttons-wrapper button:nth-child(2):focus {
	background-color: var(--pink);
}

.buttons-wrapper button:nth-child(2) {
	background-color: var(--pink);
	color: white;
	border: 1px solid white;
}

.buttons-wrapper button:hover {
	bottom: 2px;
	background-color: white;
}

.buttons-wrapper button:nth-child(2):hover {
	background-color: var(--pink);
}

.close-button {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	height: 1.2em;
	width: 1.2em;
	color: white;
	background: black;
	cursor: pointer;
}
</style>

